import React, {useState} from "react";
import "./ContentModifyPass.scss";
import {getIdWithToken} from "../../../../utils/storage/Token";
import {UpdateUserInfo} from "../../../../service/AccountService";
import FCAlertMsg, {TypeAlertMsg} from "../../../FCObjets/FCAlertMsg/FCAlertMsg";
import FCAlertMsgErrorAPI from "../../../FCObjets/FCAlertMsg/FCAlertMsgErrorAPI";

const ContentModifyPass: React.FunctionComponent = () => {

    const [inputPassword, setInputPassword] = useState("");
    const [inputPasswordVerify, setInputPasswordVerify] = useState("");
    const [showPass, setShowPass] = useState(false);
    const [showPassVerify, setShowPassVerify] = useState(false);
    const [diff, setDiff] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState<any>(null);

    const eventChangePass = (value: string, isVerify: boolean) => {
        setError(null);
        setSuccess(false);
        if (isVerify) {
            setInputPasswordVerify(value);
            setDiff(value !== inputPassword);
        } else {
            setInputPassword(value);
            setDiff(value !== inputPasswordVerify && inputPasswordVerify !== "");
        }
    };

    const handleSubmit = () => {
        setError(null);
        setSuccess(false);

        if (!inputPassword) {
            setError({message: "Veuillez saisir un mot de passe."});
            return;
        }
        if (inputPassword.length < 8) {
            setError({message: "Le mot de passe doit faire au moins 8 caractères."});
            return;
        }
        if (diff || inputPassword !== inputPasswordVerify) {
            setError({message: "Les mots de passe ne correspondent pas."});
            return;
        }

        UpdateUserInfo(getIdWithToken(), {id: getIdWithToken(), password: inputPassword})
            .then(() => {
                setSuccess(true);
                setInputPassword("");
                setInputPasswordVerify("");
                setDiff(false);
            })
            .catch((e) => setError(e));
    };

    return (
        <div className="configPage">
            <div className="configPageLabel">Sécurité</div>
            <h1 className="configPageTitle">Modifier le mot de passe</h1>
            <p className="configPageSubtitle">Choisissez un mot de passe fort pour sécuriser votre compte.</p>

            <div className="configPanel">
<div className="configPanelTitle">Nouveau mot de passe <span style={{fontSize: "11px", color: "var(--text-tertiary)", fontWeight: 400}}>(min. 8 caractères)</span></div>

                <form className="configForm" onSubmit={(e) => e.preventDefault()}>
                    <div className="configRow">
                        <div className={`configField${diff ? " configFieldError" : ""}`}>
                            <label htmlFor="pass">Mot de passe</label>
                            <div className="configFieldIcon configFieldPassWrap">
                                <span className="material-symbols-outlined">lock</span>
                                <input
                                    id="pass"
                                    type={showPass ? "text" : "password"}
                                    placeholder="••••••••"
                                    value={inputPassword}
                                    onChange={(e) => eventChangePass(e.target.value, false)}
                                />
                                <button type="button" className="configPassToggle"
                                        onClick={() => setShowPass(v => !v)} tabIndex={-1}>
                                    <span className="material-symbols-outlined">
                                        {showPass ? "visibility" : "visibility_off"}
                                    </span>
                                </button>
                            </div>
                        </div>

                        <div className={`configField${diff ? " configFieldError" : ""}`}>
                            <label htmlFor="pass2">Confirmer le mot de passe</label>
                            <div className="configFieldIcon configFieldPassWrap">
                                <span className="material-symbols-outlined">lock_check</span>
                                <input
                                    id="pass2"
                                    type={showPassVerify ? "text" : "password"}
                                    placeholder="••••••••"
                                    value={inputPasswordVerify}
                                    onChange={(e) => eventChangePass(e.target.value, true)}
                                />
                                <button type="button" className="configPassToggle"
                                        onClick={() => setShowPassVerify(v => !v)} tabIndex={-1}>
                                    <span className="material-symbols-outlined">
                                        {showPassVerify ? "visibility" : "visibility_off"}
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {diff && (
                        <FCAlertMsg
                            textMsg="Les mots de passe ne correspondent pas."
                            type={TypeAlertMsg.WARNING}
                            activate={true}
                            title="Attention"
                        />
                    )}
                    {success && (
                        <FCAlertMsg
                            textMsg="Mot de passe mis à jour avec succès."
                            type={TypeAlertMsg.SUCCESS}
                            activate={true}
                            title="Succès"
                        />
                    )}
                    {error && <FCAlertMsgErrorAPI error={error}/>}

                    <div className="configActions">
                        <button type="button" className="configBtnPrimary" onClick={handleSubmit}>
                            <span className="material-symbols-outlined">save</span>
                            Enregistrer le mot de passe
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ContentModifyPass;
